const state = () => ({
	previewList: JSON.parse(localStorage.getItem('previewData')), // 获取预览的数据列表
	showDialogList: new Array(),
	isBranchDialog: false,
	pushDialog: new Object(),
	isEnd: false
})

// getters
const getters = {
	
}

// actions
const actions = {

}

// mutations
const mutations = {
	initFirstDialog(state) {
		state.showDialogList = new Array()
		state.isEnd = false
		state.previewList = JSON.parse(localStorage.getItem('previewData'))
		const firstDialog = state.previewList.find(item => {
			return item.parent_dialog === 0 && item.search_key === ''
		})
		state.showDialogList.push(firstDialog)
	},
	appendDialogFn(state, {lastDialog}) { // 添加数据  创建一个新的数组 。不断点击查找不断往新的数组添加数据，此数据是根据阅读步骤形成的新数组 刷新当前页面需要清空 预览界面恢复空白
		if (state.isEnd) {
			return 
		}
		if (lastDialog.type === 3) {
			return 
		}
		function checkLastOne(_lastDialog) {
			const _parent_dialog_number = parseInt(_lastDialog.search_key.slice(0,-2)) 
			const _parent_dialog = state.previewList.find(item => {
				return item.dialog_number === _parent_dialog_number
			})	
			const nextDialog = state.previewList.find(item => {
				return item.parent_dialog === _parent_dialog_number
			})
			if (nextDialog === undefined) {
				if (_parent_dialog.search_key === "") {
					state.isEnd = true
				} else {
					checkLastOne(_parent_dialog)
				}
			} else {
				state.showDialogList.push(nextDialog) 
			}
		}
		// 添加的是主对话列表
		if (lastDialog.search_key === '') {
			const nextDialog = state.previewList.find(item => {
				return item.parent_dialog === lastDialog.dialog_number
			})
			if (nextDialog) {
				state.showDialogList.push(nextDialog) 
			} else {
				state.isEnd = true
			}
			return
		} 
		// 添加的是分支对话列表
		if (lastDialog.search_key !== '') {
			const nextDialog = state.previewList.find(item => {
				return item.parent_dialog === lastDialog.dialog_number
			})
			if(nextDialog) {
				state.showDialogList.push(nextDialog) 
			} else {
				checkLastOne(lastDialog)
			}
		} 
	},
	appendBranchDialogFn(state, {lastDialog,branch}) {
		if (state.isEnd) {
			return 
		}
		// 添加的是分支对话列表
		function checkLastOne(_lastDialog) {
			const _parent_dialog_number = parseInt(_lastDialog.search_key.slice(0,-2)) 
			const _parent_dialog = state.previewList.find(item => {
				return item.dialog_number === _parent_dialog_number
			})	
			const nextDialog = state.previewList.find(item => {
				return item.parent_dialog === _parent_dialog_number
			})
			if (nextDialog === undefined) {
				if (_parent_dialog.search_key === "") {
					state.isEnd = true
				} else {
					checkLastOne(_parent_dialog)
				}
			} else {
				state.showDialogList.push(nextDialog) 
			}
		}
		// 如果是从主分支对话切分支的对话
		if (lastDialog.search_key === '') {
			// 如果 jump === 0 说明分支内的对话列表为空 则在显示列表中移除此分支
			if(branch.jump === 0) {
				// 查找下一个对话
				const nextDialog = state.previewList.find(item => {
					return item.parent_dialog === branch.parent_dialog
				})
				state.showDialogList = state.showDialogList.filter(item => {
					return item.dialog_number !== branch.parent_dialog
				})
				if (nextDialog) {
					state.showDialogList.push(nextDialog)
				} else {
					state.isEnd = true
				}
			} else {
				const nextDialog = state.previewList.find(item => {
					return item.dialog_number === branch.jump
				})
				state.showDialogList = state.showDialogList.filter(item => {
					return item.dialog_number !== branch.parent_dialog
				})
				state.showDialogList.push(nextDialog)
			}
			return 
		}
		//如果是分支对话切分支
		if (lastDialog.search_key !== '') {
			if(branch.jump === 0) {
				// 查找下一个对话
				const nextDialog = state.previewList.find(item => {
					return item.parent_dialog === branch.parent_dialog
				})
				state.showDialogList = state.showDialogList.filter(item => {
					return item.dialog_number !== branch.parent_dialog
				})
				if (nextDialog) {
					state.showDialogList.push(nextDialog)
				} else {
					checkLastOne(lastDialog)
				}
			} else {
				const nextDialog = state.previewList.find(item => {
					return item.dialog_number === branch.jump
				})
				state.showDialogList = state.showDialogList.filter(item => {
					return item.dialog_number !== branch.parent_dialog
				})
				state.showDialogList.push(nextDialog)
			}
		}
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}